import { notificationApi } from '@/store/api/notificationApi';

export function groupAssetsBySite(assets: any[]): any[] {
  const siteMap = new Map<string, any>();

  for (const asset of assets) {
    const siteKey = JSON.stringify(asset.site);

    if (!siteMap.has(siteKey)) {
      siteMap.set(siteKey, {
        ...asset.site,
        assets: [],
      });
    }

    const { site, feature_name, ...cleanedAsset } = asset;

    siteMap.get(siteKey).assets.push(cleanedAsset);
  }

  return Array.from(siteMap.values());
}

export const getNotificationPreferencesAssets = (data: any) => {
  return (
    data?.flatMap((entry: any) =>
      entry.assets.map((asset: any) => ({
        ...asset,
        feature_name: entry.name,
        site: {
          enabled: entry.enabled,
          info: entry.info,
          name: entry.name,
          ui_name: entry.ui_name,
        },
      }))
    ) || []
  );
};

export const updateNotificationPreferencesCache = (key: string, newData: any) => {
  return notificationApi.util.updateQueryData('getAppPreferences', {}, (draft) => {
    const target = draft.find((item: any) => item.name === key);
    if (target) {
      target.assets = newData;
    }
  });
};
